module.exports = __webpack_public_path__ + "7f4aa3b91cdcbb4997e8c4f4f9001d87.svg";